import React, {useEffect, useState} from 'react';
import {X} from "react-feather";
import {
    deleteConversationAccountDelete,
    getVendorAccounts,
    postConversationAccountAdd
} from "../../services/api/messaging";
import Modal from "react-modal";
import AccountFilter from "../Input/AccountFilter";
import Switch from "react-ios-switch";
import {Spinner} from "flowbite-react";
import ModalOneAccountVendor from "../Messaging/ModalOneAccountVendor";

const ForwardModal = ({authData, conversation, participants, onConversationSyncUsers, handleClose}) => {

    const [allVendorAccounts, setAllVendorAccounts] = useState(null);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [stayInConversation, setStayInConversation] = useState(true);
    const participantIds = new Set(participants.map(participant => participant.id));
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [vendorPrimaryEmail, setVendorPrimaryEmail] = useState(null);

    useEffect(() => {

            const fetchAllVendorAccounts = async () => {
                try {
                    setIsLoading(true);
                    const vendors = await getVendorAccounts(authData.company.id);
                    const primaryAccountEmail = vendors?.find(vendor => vendor.is_primary)?.username;
                    setVendorPrimaryEmail(primaryAccountEmail);
                    setAllVendorAccounts(vendors.filter(vendor => vendor.id !== authData.id && !participantIds.has(vendor.id)));
                    setIsLoading(false);
                } catch (error) {
                    console.error('Error fetching vendor accounts:', error);
                    setIsLoading(false);
                }
            }

            if (!allVendorAccounts) {
                fetchAllVendorAccounts().then(() => console.log(''));
            }
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        [allVendorAccounts, participants]);

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);
            if (selectedVendors.length > 0) {
                await Promise.all(selectedVendors.map(vendor => postConversationAccountAdd(conversation.id, vendor)));
            }

            if (!stayInConversation) {
                await deleteConversationAccountDelete(conversation.id, authData.id)
            }

            onConversationSyncUsers();
            setIsSubmitting(false);
            handleClose();
        } catch (error) {
            setIsSubmitting(false);
            console.error('Error forwarding conversation:', error);
        }

    }

    if (allVendorAccounts?.length === 0) {
        return <ModalOneAccountVendor title={'Forward conversation'} handleClose={handleClose}/>;
    }


    return (
        <Modal
            isOpen={true}
            onRequestClose={handleClose}
            className="sl-modal-content sl-max-h-185"
            overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
            <div className="">
                <div
                    className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                    <div className="sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                        <div>Forward conversation</div>
                    </div>
                    <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={handleClose}>
                        <X/>
                    </div>
                </div>

                <div
                    className="sl-modal-body sl-h-auto sl-max-h-112 sl-customized-scrollbar sl-overflow-y-auto sl-px-6 sl-pb-0 sl-pt-24 sl-flex sl-flex-col sl-gap-3">

                    {isLoading && <Spinner/>}
                    {!isLoading && allVendorAccounts?.length > 0 &&
                        <AccountFilter
                            skipPrimary={true}
                            accounts={allVendorAccounts} selectedIds={selectedVendors}
                            onSelectedIdsChange={(val) => {
                                setSelectedVendors(val);
                            }}/>}
                </div>

                {allVendorAccounts && <div className={"sl-pr-8 sl-pl-8  sl-pt-16"}>

                    <span className="sl-text-gray-500 sl-font sl-text-sm sl-font-normal">
                        Don’t see your contact here? <a
                        href={`mailto:${vendorPrimaryEmail}`}
                        className={"sl-cursor-pointer sl-text-primary-700"}>Contact</a> your administrator to add it.</span>

                    <div className={"sl-content-divider sl-pt-8 sl-pb-8"}/>

                    <div className={"sl-flex sl-flex-row sl-gap-3"}>

                        <div className={"sl-ios-switch-wrap"}>
                            <Switch
                                height={24}
                                width={44}
                                offColor="white"
                                onColor="#1570EF"
                                checked={stayInConversation} onChange={(value) => {
                                setStayInConversation(value);

                            }}/>
                        </div>

                        <div className={"sl-flex sl-flex-col"}>
                            <span className="sl-text-gray-700 sl-font sl-text-md sl-font-medium">Stay in the conversation</span>
                            <span className="sl-text-gray-500 sl-font sl-text-sm sl-font-normal">
                            This will create a group chat. Turning off this toggle removes you from future messages unless you're added again.
                        </span>
                        </div>
                    </div>
                </div>}

                <div className="sl-modal-footer sl-px-6 sl-py-32">
                    <div
                        className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">

                        <button onClick={handleClose}
                                className="sl-btn sl-btn-clear sl-btn-lg sl-rounded-lg sl-border-gray-300 sl-border-1 sl-border-solid ">
                            Cancel
                        </button>
                        <button
                            disabled={selectedVendors.length === 0 || isSubmitting}
                            onClick={handleSubmit}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">

                            {isSubmitting && <span>Sending... <Spinner aria-label="Default status example"/></span>}
                            {!isSubmitting && 'Send'}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ForwardModal;
